import { branding } from '@/config/branding'
import { cn } from '@/lib/utils'
import { HelpCircle, type LucideIcon } from 'lucide-react'
import type React from 'react'

interface ErrorStateProps {
	title: string
	message?: string | React.ReactNode
	showSupportEmail?: boolean
	className?: string
	containerClassName?: string
	icon?: LucideIcon
	iconClassName?: string
	actions?: React.ReactNode
}

export function ErrorState({
	title,
	message,
	showSupportEmail = true,
	className = '',
	containerClassName,
	icon: Icon = HelpCircle,
	iconClassName = 'text-warning',
	actions,
}: ErrorStateProps) {
	const defaultMessage = showSupportEmail ? (
		<>
			Please contact{' '}
			<a
				href={`mailto:${branding.supportEmail}`}
				className='text-primary hover:underline'
				data-testid='error-state-support-link'>
				{branding.supportEmail}
			</a>{' '}
			for assistance
		</>
	) : (
		'Something went wrong'
	)

	return (
		<div className={cn('flex items-center justify-center py-8 w-full h-full', containerClassName)}>
			<div className={cn('text-center space-y-2 max-w-sm', className)}>
				<Icon className={cn('size-(--icon-standalone) mx-auto', iconClassName)} />
				<div className='space-y-1'>
					<p className='text-body font-medium text-foreground'>{title}</p>
					<p className='text-control text-muted-foreground'>{message ?? defaultMessage}</p>
				</div>
				{actions && <div className='flex gap-2 justify-center pt-2'>{actions}</div>}
			</div>
		</div>
	)
}
